import React from "react";
import { BrowserRouter, Routes, Route, Link, NavLink } from "react-router-dom"
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { useLanguage } from '../i18n/translations';

export default function Dostava({ categories }) {
    const { translate } = useLanguage();
    return (
        <div className="bg-gray-100 text-gray-800">
            <SEO
                title="Informacije o dostavi - Bulka Ceramics"
                description=""
                type="website"
                name="Bulka Ceramics"
            />

            <div className="container mx-auto p-6">

                <div className="mb-12 bg-white p-6 rounded-lg shadow">
                    <h1 className="text-2xl font-bold mb-4">{translate("Delivery & Returns")}</h1>
                    <h2 className="text-xl font-semibold mb-2">{translate("Shipping")}</h2>
                    <ul className="list-disc list-inside mb-4">
                        <li><strong>{translate("For Serbia:")}</strong> {translate("Delivery within 30 days.")}</li>
                        <li><strong>{translate("For Bosnia and Herzegovina:")}</strong> {translate("Delivery within 20 days.")}</li>
                        <li><strong>{translate("For Montenegro:")}</strong> {translate("By arrangement.")}</li>
                        <li><strong>{translate("For Croatia:")}</strong> {translate("By arrangement.")}</li>
                    </ul>
                    <p className="mb-2">{translate("If your product is damaged during delivery, please send us photos of the damaged item within 3 business days. In that case, we can send a new product or issue a refund.")}</p>
                    <p className="mb-2">{translate("If we have the product available, we can replace it immediately. If the product is not available, we will issue a refund.")}</p>
                    <p className="mb-2">{translate("If you would like to return a product, please contact us at:")} <a href="mailto:contact@bulkaceramics.com" className="text-blue-500">contact@bulkaceramics.com</a>. {translate("Our team will help you with all the necessary information and the return process.")}</p>
                    <p>{translate("For international delivery, feel free to contact us at the same email.")}</p>
                </div>



            </div>
            <Footer categories={categories} />
        </div>
    )
}